export const tipoConta = {
	CC: 'Conta Corrente',
	P: 'Poupança',
	F: 'Fundo',
	A: 'Aplicação',
	CT: 'Cotas',
	C: 'Caixa',
};
